<!-- Backdrop + vùng bắt phím -->
<div
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  *ngIf="isVisible"
  (click)="close()"                
  (keydown.escape)="close()"       
  tabindex="-1"                   
  aria-hidden="false">

  <!-- Modal panel -->
  <div
    class="bg-white rounded-lg shadow-lg w-full max-w-4xl flex flex-col max-h-[90vh]"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="'upload-modal-title'"
    [attr.aria-busy]="uploading ? 'true' : 'false'"
    (click)="$event.stopPropagation()"> <!-- chặn click từ panel -->
    
    <!-- Header -->
    <div class="p-4 border-b flex justify-between items-center flex-shrink-0">
      <h2 id="upload-modal-title" class="text-lg font-bold">📤 Tải ảnh / video lên</h2>
      <button type="button" (click)="close()" class="text-gray-400 hover:text-red-500" aria-label="Đóng">✖</button>
    </div>

    <!-- File input + Privacy -->
    <div class="p-4 border-b flex-shrink-0 space-y-4">
      <!-- File input -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2" for="upload-file-input">📁 Chọn file:</label>
        <input 
          id="upload-file-input"
          #fileInput
          type="file" 
          multiple
          accept="image/*,video/*"
          (change)="onFileSelected($event)"
          class="block w-full text-sm text-gray-600 border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          [disabled]="uploading"
        />
      </div>

      <!-- Privacy Dropdown -->
      <div class="flex items-center gap-4">
        <label class="text-sm font-medium text-gray-700" for="privacy-select">🔒 Quyền riêng tư:</label>
        <div class="relative">
          <select 
            id="privacy-select"
            [(ngModel)]="selectedPrivacy"
            class="appearance-none bg-white border border-gray-300 rounded-lg px-4 py-2 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer"
            [disabled]="uploading">
            <option value="public">🌍 Công khai</option>
            <option value="friends">👥 Bạn bè</option>
            <option value="private">🔒 Riêng tư</option>
          </select>
          <div class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </div>
        </div>

        <div class="text-xs text-gray-500" aria-live="polite">
          <span *ngIf="selectedPrivacy === 'public'">Mọi người có thể xem</span>
          <span *ngIf="selectedPrivacy === 'friends'">Chỉ bạn bè có thể xem</span>
          <span *ngIf="selectedPrivacy === 'private'">Chỉ bạn có thể xem</span>
        </div>
      </div>
    </div>

    <!-- Preview list -->
    <div class="flex-1 overflow-y-auto p-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
      <div 
        class="bg-gray-100 p-3 rounded-lg relative"
        *ngFor="let file of selectedFiles; let i = index">
        <div class="w-full h-32 bg-white flex items-center justify-center rounded-md overflow-hidden border border-gray-300">
          <img *ngIf="file.type.startsWith('image/')" [src]="file.preview" [alt]="file.name" class="object-cover w-full h-full">
          <video *ngIf="file.type.startsWith('video/')" [src]="file.preview" controls class="object-cover w-full h-full"></video>
        </div>

        <p class="mt-2 font-medium text-sm truncate" [title]="file.name">{{ file.name }}</p>
        <p class="text-xs text-gray-500">{{ (file.size / 1024).toFixed(1) }} KB</p>

        <label class="sr-only" [for]="'cmt-'+i">Ghi chú cho {{file.name}}</label>
        <textarea 
          [id]="'cmt-'+i"
          [(ngModel)]="file.comment" 
          placeholder="Nhập ghi chú..."
          class="mt-1 w-full border border-gray-300 rounded-lg p-1 text-xs resize-y"
          [disabled]="uploading"></textarea>

        <button 
          type="button"
          (click)="removeFile(i)"
          class="absolute top-2 right-2 text-gray-400 hover:text-red-500 transition"
          [disabled]="uploading"
          aria-label="Xoá file">
          ❌
        </button>
      </div>
    </div>

    <!-- Footer actions -->
    <div class="p-4 border-t flex justify-between items-center flex-shrink-0 sticky bottom-0 bg-white">
      <!-- Privacy summary -->
      <div class="flex items-center gap-2 text-sm text-gray-600" aria-live="polite">
        <span *ngIf="selectedPrivacy === 'public'" class="flex items-center gap-1">🌍 <span>Công khai</span></span>
        <span *ngIf="selectedPrivacy === 'friends'" class="flex items-center gap-1">👥 <span>Bạn bè</span></span>
        <span *ngIf="selectedPrivacy === 'private'" class="flex items-center gap-1">🔒 <span>Riêng tư</span></span>
        <span class="text-gray-400">• {{ selectedFiles.length }} file(s)</span>
      </div>

      <!-- Action buttons -->
      <div class="flex gap-2">
        <button 
          type="button"
          (click)="upload()" 
          [disabled]="uploading || selectedFiles.length === 0"
          class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded disabled:bg-gray-400 flex items-center gap-2"
          [attr.aria-busy]="uploading ? 'true' : null">
          <span *ngIf="!uploading">📤 Tải lên</span>
          <span *ngIf="uploading">⏳ Đang tải...</span>
        </button>
        <button 
          type="button"
          (click)="close()" 
          class="bg-gray-300 hover:bg-gray-400 px-4 py-2 rounded flex items-center gap-2">
          ✖ <span>Huỷ</span>
        </button>
      </div>
    </div>
  </div>
</div>
